"use client";
import {
  InquiryCreateRequest,
  inquiryCreateRequestSchema,
} from "@vereinsheim/backend-types/src/inquiry";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Button from "@/app/pwa/components/Button";
import { ErrorText } from "@/app/pwa/components/form/ErrorText";
import TextArea from "@/app/pwa/components/form/Textarea";
import { zodResolver } from "@hookform/resolvers/zod";
import Label from "@/app/pwa/components/form/Label";
import { InputField } from "@/app/pwa/components/form/InputField";
import {tryParseResponseError} from "@/app/utils/tryParseResponseError";

export function InquiryForm() {
  const [loading, setLoading] = useState(false);
  const [backendError, setBackendError] = useState<string | null>(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<InquiryCreateRequest>({
    resolver: zodResolver(inquiryCreateRequestSchema),
  });
  const { push } = useRouter();
  async function submit(data: InquiryCreateRequest) {
    setLoading(true);
    const res = await fetch("/api/inquiry", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    });
    setLoading(false);
    if (res.ok) {
      push("/inquiry/confirmation");
    } else {
      const errorMessage = await tryParseResponseError(res);
      setBackendError(errorMessage);
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(submit)} className="">
        <div className="flex flex-col">
          <InputField
            register={register("functionType")}
            id="functionType"
            placeholder="z. B. Vorstand..."
            label="Position im Verein"
            error={errors.functionType}
          />
        </div>
        <div className="flex flex-col">
          <InputField
            register={register("name")}
            id="name"
            placeholder="Name..."
            label="Name im Verein"
            error={errors.name}
          />
        </div>
        <div className="flex flex-col mt-4">
          <TextArea
            id="message"
            {...register("message")}
            rows={5}
            className="peer mt-1"
            placeholder="Stelle dich bitte kurz vor..."
          />
          <Label htmlFor="message" className="order-first">
            Deine Nachricht an uns
          </Label>
          {errors.message && (
            <ErrorText className="mt-1 text-sm">
              {errors.message?.message}
            </ErrorText>
          )}
        </div>
        <div className="mt-6 w-full">
          <Button
            type="submit"
            color="primary"
            className="w-full justify-center"
            loading={loading}
          >
            Antrag absenden
          </Button>
        </div>
        {backendError && (
          <ErrorText className={`mt-1 text-sm`}>{backendError}</ErrorText>
        )}
      </form>
    </>
  );
}
